module.exports = __webpack_public_path__ + "img/IndexManselect.f7ad97a8.svg";